export const AMERICANAS = '4d600792-e73a-4e3f-b7b1-0447b8c4bb94'
export const FASTSHOP = '974b02b9-bfda-4a7c-ac10-2bd5b1d29a37'
export const RM_TESTES_PUBLISHER = '0d675bf6-03f6-4b81-9617-e79dffddc3ab'
export const CB = '3b7bcd3a-fde6-42d1-8de4-47a6e41a415a'
export const CB_STAGING = 'd4dff0cb-1f21-4a96-9acf-d9426a5ed08c'
export const DPSP = 'b0b09b5b-71db-4c79-a664-601a659a412a'
export const SEPHORA = 'bd246986-bd26-4ac4-b2f7-5e81a4cdbc18'
export const PM = '47e240a0-61f7-46fd-8056-81288de6d724'
export const KABUM_PID = 'fc855527-f0b7-4438-b30a-9ea3284241d8'
export const KABUM_STG_PID = '5eb876a8-4844-4be3-9b69-086642bc7d21'
export const TOTALPASS_STG_PID = '2674c980-4292-4106-89c9-6f8c5cfc3f5c'
export const PICPAY_PID = 'c45672a2-6cf3-4914-8e3c-e8767ccb4bf2'
export const PICPAY_STG_PID = '11ae8dbc-b5e8-4c4e-af76-3e8a8fd01f5f'
export const OLIMPICA_PID = '5abb54df-c015-4ec5-90b2-60cd79a94911'
export const BEMOL_PID = '62180195-2bb8-4234-a72a-a3eacf075ada'
export const BEMOL_QA_PID = '26c3fd81-2393-4bd5-8f39-fa3becb689e8'
export const SUPER_XTRA = '6294137c-1b46-4092-8d57-baca92e3aa4f'
export const AUCHAN_POC = '553b98fb-4dbe-47e6-93a2-7752fadd8e7e'
export const TENDA = '40bdfa62-6db9-4944-8ea3-fb718287b212'

// VTEX APP
export const NEWTAILPARTNERBR = '30d662e6-c5f8-418d-9c77-15ab0641eb7b'

export const AMOBELEZA = '9b48172b-3e5d-4250-9014-e225223185c8'
// VTEX DAY
export const VTEX_GROCERY = '75b9cf34-a213-4a97-a2fc-f7c09ce34abd'
export const VTEX_GROCERY_B2B = 'c08a86bc-ab4e-48bf-b0f2-96dd30c28d5b'

export const ONCITY_PID = '43473a0b-c9f0-49ba-aeae-155bfb662a35'
export const ELETRO_ANGELONI_PID = '103eca18-ca75-425c-b099-b335fbc71aed'
